import React from 'react'
import { Spinner } from '@shopify/polaris'
import LappaPolarisDataTableShell from './LappaPolarisDataTableShell'

/**
 * List-page table: Lappa shell + loading, without Polaris Card wrapper.
 */
export default function LappaListTable({
	loading = false,
	isEmpty = false,
	emptyState = null,
	tableClassName = '',
	shellClassName = 'LappaTablePage__tableArea',
	columnContentTypes,
	headings,
	rows,
	...dataTableProps
}) {
	if (loading) {
		return (
			<div className='LappaTablePage__loading' role='status' aria-live='polite'>
				<Spinner />
			</div>
		)
	}

	return (
		<LappaPolarisDataTableShell
			shellClassName={shellClassName}
			tableClassName={tableClassName}
			isEmpty={isEmpty}
			emptyState={emptyState}
			columnContentTypes={columnContentTypes}
			headings={headings}
			rows={rows}
			{...dataTableProps}
		/>
	)
}
